import ReactiveRecord, { Model } from 'reactiverecord';

class Industry extends Model {
  static schema = {
    name: String,
  };
}

export default ReactiveRecord.model('Industry', Industry);
